// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jp-wrap {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.jp-body {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 40px;
}

/* Gantt overview */
.jp-gantt-wrap {
  border-bottom: 1px solid var(--border);
  background: var(--bg-secondary);
  overflow-x: auto;
  flex-shrink: 0;
  margin-bottom: 12px;
}
.jp-gantt-scroll {
  position: relative;
}
.jp-gantt-hdr {
  position: relative;
  border-bottom: 1px solid var(--border);
  background: var(--bg-tertiary);
  overflow: hidden;
}
.jp-gantt-month {
  position: absolute;
  top: 0; bottom: 0;
  display: flex; align-items: center;
  padding-left: 6px;
  font-size: 11px;
  color: var(--text-muted);
  border-right: 1px solid var(--border);
  white-space: nowrap;
  overflow: hidden;
}
.jp-gantt-today {
  position: absolute;
  top: 0; bottom: 0;
  width: 1px;
  background: rgba(255, 100, 100, 0.6);
  z-index: 2;
  pointer-events: none;
}
.jp-gantt-row {
  position: relative;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}
.jp-gantt-bar {
  position: absolute;
  top: 5px;
  height: 22px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: default;
}
.jp-gantt-bar-label {
  font-size: 10px;
  color: rgba(255,255,255,0.9);
  padding: 0 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Package cards */
.jp-card {
  border: 1px solid var(--border);
  border-radius: 4px;
  margin: 0 16px 8px;
  background: var(--bg-secondary);
  overflow: hidden;
}
.jp-card.jp-unread {
  border-color: #f0a04b44;
}
.jp-card-new {
  border-color: var(--accent-light);
}
.jp-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  user-select: none;
  min-height: 44px;
}
.jp-card-header:hover { background: var(--bg-hover); }
.jp-card-chevron { color: var(--text-muted); flex-shrink: 0; }
.jp-status-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.jp-status-dot-btn {
  border: none;
  padding: 0;
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
}
.jp-status-dot-btn:hover {
  transform: scale(1.4);
  box-shadow: 0 0 0 2px rgba(255,255,255,0.15);
}

.jp-status-filter {
  display: flex;
  gap: 4px;
  margin-left: 4px;
}
.jp-filter-btn {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 3px;
  border: 1px solid var(--border);
  background: none;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.1s, border-color 0.1s;
}
.jp-filter-btn:hover { color: var(--text-primary); border-color: var(--text-muted); }
.jp-filter-btn.active { color: var(--text-primary); border-color: var(--text-secondary); background: var(--bg-active); }
.jp-pkg-project {
  font-size: 11px;
  color: #4fc1ff;
  background: rgba(79,193,255,0.1);
  border: 1px solid rgba(79,193,255,0.3);
  border-radius: 3px;
  padding: 1px 5px;
  flex-shrink: 0;
}
.jp-pkg-number {
  font-family: monospace;
  font-size: 11px;
  color: var(--text-muted);
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 3px;
  padding: 1px 5px;
  flex-shrink: 0;
}
.jp-pkg-orderno {
  font-size: 11px;
  color: #f0a04b;
  background: rgba(240,160,75,0.1);
  border: 1px solid rgba(240,160,75,0.3);
  border-radius: 3px;
  padding: 1px 5px;
  flex-shrink: 0;
}
.jp-card-name {
  font-size: 13px;
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.jp-unread-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #f0a04b;
  flex-shrink: 0;
}
.jp-card-dates {
  font-size: 11px;
  color: var(--text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}
.jp-card-assignees {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.jp-more-assignees {
  font-size: 11px;
  color: var(--text-muted);
  margin-left: 2px;
}
.jp-card-status-label {
  font-size: 11px;
  font-weight: 500;
  flex-shrink: 0;
  min-width: 80px;
  text-align: right;
}
.jp-card-actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.jp-card-actions .jp-edit-del {
  display: flex;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.1s;
}
.jp-card-header:hover .jp-card-actions .jp-edit-del { opacity: 1; }
@media (hover: none) {
  .jp-card-actions .jp-edit-del { opacity: 1; }
}

/* ── Mobile ── */
@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  /* Toolbar: title on top, filters + new button below */
  .jp-wrap .module-toolbar {
    flex-wrap: wrap;
    padding: 8px 12px;
    gap: 6px;
  }
  .jp-wrap .module-toolbar-title {
    width: 100%;
    margin-right: 0;
  }
  .jp-status-filter { flex: 1; }
  .jp-filter-btn {
    font-size: 11px;
    padding: 5px 6px;
    flex: 1;
    text-align: center;
  }

  /* Cards */
  .jp-card { margin: 0 8px 6px; }
  .jp-card-header { gap: 6px; padding: 10px 10px; min-height: 52px; }
  .jp-card-dates        { display: none; }
  .jp-card-status-label { display: none; }
  .jp-card-assignees    { display: none; }
  .jp-card-name { font-size: 13px; }
  .jp-gantt-wrap { display: none; }

  /* Bigger tap targets for card action buttons */
  .jp-card-actions { gap: 6px; }
  .jp-card-actions .btn-icon { width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; }

  /* Status dot bigger tap target */
  .jp-status-dot-btn { width: 20px; height: 20px; }

  /* Form: stack all rows vertically */
  .jp-form-row { flex-direction: column; gap: 8px; }
  .jp-form-label { min-width: 0; }
  .jp-input { font-size: 16px !important; } /* prevent iOS zoom */

  /* Bigger checklist touch targets */
  .jp-checkitem { padding: 10px 6px; min-height: 44px; font-size: 13px; }
  .jp-checkitem input[type="checkbox"] { width: 18px; height: 18px; flex-shrink: 0; }
  .jp-checklist { max-height: 220px; }
  .jp-checklist-scroll { max-height: 260px; }

  /* File picker: stack vertically */
  .jp-filepicker-body { flex-direction: column; height: auto; }
  .jp-filepicker-folders {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--border);
    max-height: 130px;
    display: flex;
    flex-wrap: wrap;
    padding: 4px;
    gap: 4px;
  }
  .jp-filepicker-folder { width: auto; padding: 6px 10px; border: 1px solid var(--border); border-radius: 3px; }
  .jp-filepicker-folder.active { background: var(--bg-active); }
  .jp-filepicker-files { max-height: 200px; }
  .jp-filepicker-file { padding: 8px 6px; min-height: 40px; font-size: 13px; }

  /* Form action buttons full width */
  .jp-form-actions { flex-direction: column; }
  .jp-form-actions .btn-primary,
  .jp-form-actions .btn-secondary { width: 100%; justify-content: center; padding: 10px; font-size: 14px; }

  /* Cable table: full columns, horizontal scroll */
  .jp-detail-full { overflow-x: auto; -webkit-overflow-scrolling: touch; }
  .jp-cable-table { min-width: 480px; width: max-content; }
  .jp-cable-table td:last-child input[type="checkbox"] { width: 22px; height: 22px; }

  /* Detail items bigger */
  .jp-detail-item { padding: 6px 0; font-size: 13px; }

  .jp-body { padding-bottom: 60px; }
}

.jp-card-title {
  font-size: 13px;
  font-weight: 600;
  padding: 10px 14px 0;
  color: var(--text-primary);
}
.jp-card-body {
  padding: 12px 14px 14px;
  border-top: 1px solid var(--border);
}

/* Form */
.jp-form { display: flex; flex-direction: column; gap: 10px; }
.jp-form-row { display: flex; gap: 12px; flex-wrap: wrap; }
.jp-form-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  color: var(--text-muted);
  flex: 1;
  min-width: 120px;
}
.jp-input {
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 3px;
  color: var(--text-primary);
  font-size: 13px;
  padding: 5px 8px;
  outline: none;
  width: 100%;
  box-sizing: border-box;
}
.jp-input:focus { border-color: var(--accent-light); }
.jp-textarea { resize: vertical; min-height: 60px; font-family: inherit; }
.jp-form-section {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 0 2px;
  border-bottom: 1px solid var(--border);
}
.jp-checklist {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 120px;
  overflow-y: auto;
  padding: 2px 0;
}
.jp-checklist-scroll { max-height: 140px; }
.jp-checkitem {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-primary);
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 2px;
}
.jp-checkitem:hover { background: var(--bg-hover); }
.jp-search-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  color: var(--text-muted);
  margin-bottom: 2px;
}
.jp-search-input { flex: 1 1 160px; }
.jp-search-row .group-filter { width: auto; flex: 0 1 170px; }
.jp-select-all { font-size: 12px; padding: 4px 10px; white-space: nowrap; }
.jp-form-section .jp-muted { text-transform: none; letter-spacing: 0; font-weight: 400; }
.jp-tag {
  font-family: monospace;
  font-size: 11px;
  background: var(--bg-tertiary);
  padding: 1px 5px;
  border-radius: 2px;
  color: var(--text-secondary);
  flex-shrink: 0;
  white-space: nowrap;
}
.jp-muted { font-size: 11px; color: var(--text-muted); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.jp-files-selected { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 6px; }
.jp-file-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 11px;
  color: var(--text-secondary);
}
.jp-file-chip-remove {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0;
  display: flex;
  align-items: center;
}
.jp-file-chip-remove:hover { color: #e06c75; }
.jp-add-files-btn { margin-top: 2px; }
.jp-form-actions { display: flex; gap: 8px; margin-top: 4px; }

/* File picker */
.jp-filepicker {
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--bg-secondary);
  margin-top: 6px;
  overflow: hidden;
}
.jp-filepicker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border);
  font-size: 12px;
  color: var(--text-secondary);
}
.jp-filepicker-body { display: flex; height: 160px; }
.jp-filepicker-folders {
  width: 140px;
  border-right: 1px solid var(--border);
  overflow-y: auto;
  padding: 4px 0;
}
.jp-filepicker-folder {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  text-align: left;
  padding: 5px 10px;
  font-size: 12px;
  color: var(--text-secondary);
  background: none;
  border: none;
  cursor: pointer;
}
.jp-filepicker-folder:hover, .jp-filepicker-folder.active { background: var(--bg-hover); color: var(--text-primary); }
.jp-filepicker-files {
  flex: 1;
  overflow-y: auto;
  padding: 4px 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.jp-filepicker-file {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary);
  padding: 3px 4px;
  border-radius: 2px;
  cursor: pointer;
}
.jp-filepicker-file:hover { background: var(--bg-hover); }
.jp-filepicker-empty { font-size: 11px; color: var(--text-muted); padding: 8px; }

/* Detail view */
.jp-description { font-size: 13px; color: var(--text-secondary); margin: 0 0 10px; line-height: 1.5; }
.jp-detail-grid { display: flex; gap: 16px; flex-wrap: wrap; }
.jp-detail-section { flex: 1; min-width: 180px; }
.jp-detail-full { flex-basis: 100%; min-width: 0; }

/* Cable table inside job package detail */
.jp-cable-table { width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 4px; }
.jp-cable-table th {
  text-align: left;
  color: var(--text-muted);
  font-weight: 500;
  padding: 2px 8px 4px 0;
  border-bottom: 1px solid var(--border);
}
.jp-cable-table td { padding: 3px 8px 3px 0; color: var(--text-secondary); vertical-align: middle; }
.jp-cable-table tr:hover td { background: var(--bg-hover); }
.jp-arrow { color: var(--text-muted); padding: 0 2px !important; }
.jp-detail-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 6px;
}
.jp-detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
  font-size: 12px;
  color: var(--text-secondary);
  overflow: hidden;
}
.jp-file-link {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--accent-light);
  font-size: inherit;
  font-family: inherit;
  text-align: left;
}
.jp-file-link:hover { text-decoration: underline; }

/* Tag + yellow/red notice badges (same badges as the Items/Cables lists) */
/* Photo button + notices next to a cable/item tag. Photo first, so the cameras line up */
.jp-icons { display: inline-flex; align-items: center; gap: 4px; flex-shrink: 0; }
.jp-icons .photo-btn { flex-shrink: 0; }
.jp-cable-table td.jp-icons-td { padding-right: 12px; white-space: nowrap; }
.jp-detail-item .jp-icons { min-width: 46px; }
.jp-icons .rn-wrap { flex-wrap: nowrap; }
@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .jp-icons { gap: 6px; }
  .jp-icons .photo-btn { width: 30px; height: 30px; }
  .jp-detail-item .jp-icons { min-width: 56px; }
}
.jp-detail-item:hover .photo-btn-empty { opacity: 0.55; }
.jp-detail-item .photo-btn-empty:hover { opacity: 1; }
`, "",{"version":3,"sources":["webpack://./src/components/jobpackages/JobPackageView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM,EAAE,SAAS;EACjB,aAAa,EAAE,mBAAmB;EAClC,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM,EAAE,SAAS;EACjB,UAAU;EACV,oCAAoC;EACpC,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA,wBAAwB,2BAA2B,EAAE;AACrD,mBAAmB,wBAAwB,EAAE,cAAc,EAAE;AAC7D;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yCAAyC;AAC3C;AACA,uBAAuB,0BAA0B,EAAE,+BAA+B,EAAE;AACpF,wBAAwB,0BAA0B,EAAE,mCAAmC,EAAE,4BAA4B,EAAE;AACvH;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;AACA,sDAAsD,UAAU,EAAE;AAClE;EACE,gCAAgC,UAAU,EAAE;AAC9C;;AAEA,iBAAiB;AACjB;EACE,sDAAsD;EACtD;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA,oBAAoB,OAAO,EAAE;EAC7B;IACE,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,kBAAkB;EACpB;;EAEA,UAAU;EACV,WAAW,iBAAiB,EAAE;EAC9B,kBAAkB,QAAQ,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;EAClE,wBAAwB,aAAa,EAAE;EACvC,wBAAwB,aAAa,EAAE;EACvC,wBAAwB,aAAa,EAAE;EACvC,gBAAgB,eAAe,EAAE;EACjC,iBAAiB,aAAa,EAAE;;EAEhC,+CAA+C;EAC/C,mBAAmB,QAAQ,EAAE;EAC7B,6BAA6B,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;;EAErH,iCAAiC;EACjC,qBAAqB,WAAW,EAAE,YAAY,EAAE;;EAEhD,oCAAoC;EACpC,eAAe,sBAAsB,EAAE,QAAQ,EAAE;EACjD,iBAAiB,YAAY,EAAE;EAC/B,YAAY,0BAA0B,EAAE,EAAE,qBAAqB;;EAE/D,mCAAmC;EACnC,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE;EACtE,uCAAuC,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;EAClF,gBAAgB,iBAAiB,EAAE;EACnC,uBAAuB,iBAAiB,EAAE;;EAE1C,kCAAkC;EAClC,sBAAsB,sBAAsB,EAAE,YAAY,EAAE;EAC5D;IACE,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,QAAQ;EACV;EACA,wBAAwB,WAAW,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;EAC7G,+BAA+B,4BAA4B,EAAE;EAC7D,uBAAuB,iBAAiB,EAAE;EAC1C,sBAAsB,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;EAE3E,mCAAmC;EACnC,mBAAmB,sBAAsB,EAAE;EAC3C;oCACkC,WAAW,EAAE,uBAAuB,EAAE,aAAa,EAAE,eAAe,EAAE;;EAExG,iDAAiD;EACjD,kBAAkB,gBAAgB,EAAE,iCAAiC,EAAE;EACvE,kBAAkB,gBAAgB,EAAE,kBAAkB,EAAE;EACxD,uDAAuD,WAAW,EAAE,YAAY,EAAE;;EAElF,wBAAwB;EACxB,kBAAkB,cAAc,EAAE,eAAe,EAAE;;EAEnD,WAAW,oBAAoB,EAAE;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,SAAS;AACT,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC7D,eAAe,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA,kBAAkB,iCAAiC,EAAE;AACrD,eAAe,gBAAgB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AACzE;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,uBAAuB,iBAAiB,EAAE;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,sBAAsB,2BAA2B,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;AACpB;AACA,mBAAmB,eAAe,EAAE;AACpC,+BAA+B,WAAW,EAAE,eAAe,EAAE;AAC7D,iBAAiB,eAAe,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC1E,6BAA6B,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACxF;EACE,sBAAsB;EACtB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;AACrB;AACA,YAAY,eAAe,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvH,qBAAqB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACnF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA,6BAA6B,cAAc,EAAE;AAC7C,oBAAoB,eAAe,EAAE;AACrC,mBAAmB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAE7D,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,4BAA4B;AAC9B;AACA,sBAAsB,aAAa,EAAE,aAAa,EAAE;AACpD;EACE,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA,4DAA4D,2BAA2B,EAAE,0BAA0B,EAAE;AACrH;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,4BAA4B,2BAA2B,EAAE;AACzD,uBAAuB,eAAe,EAAE,wBAAwB,EAAE,YAAY,EAAE;;AAEhF,gBAAgB;AAChB,kBAAkB,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACrG,kBAAkB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7D,qBAAqB,OAAO,EAAE,gBAAgB,EAAE;AAChD,kBAAkB,gBAAgB,EAAE,YAAY,EAAE;;AAElD,0CAA0C;AAC1C,kBAAkB,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC5F;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;AACxC;AACA,qBAAqB,sBAAsB,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;AACnG,8BAA8B,2BAA2B,EAAE;AAC3D,YAAY,wBAAwB,EAAE,yBAAyB,EAAE;AACjE;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;AACA,sBAAsB,0BAA0B,EAAE;;AAElD,2EAA2E;AAC3E,yFAAyF;AACzF,YAAY,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACjF,uBAAuB,cAAc,EAAE;AACvC,iCAAiC,mBAAmB,EAAE,mBAAmB,EAAE;AAC3E,4BAA4B,eAAe,EAAE;AAC7C,qBAAqB,iBAAiB,EAAE;AACxC;EACE,YAAY,QAAQ,EAAE;EACtB,uBAAuB,WAAW,EAAE,YAAY,EAAE;EAClD,4BAA4B,eAAe,EAAE;AAC/C;AACA,yCAAyC,aAAa,EAAE;AACxD,yCAAyC,UAAU,EAAE","sourcesContent":[".jp-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.jp-body {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 40px;\n}\n\n/* Gantt overview */\n.jp-gantt-wrap {\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-secondary);\n  overflow-x: auto;\n  flex-shrink: 0;\n  margin-bottom: 12px;\n}\n.jp-gantt-scroll {\n  position: relative;\n}\n.jp-gantt-hdr {\n  position: relative;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-tertiary);\n  overflow: hidden;\n}\n.jp-gantt-month {\n  position: absolute;\n  top: 0; bottom: 0;\n  display: flex; align-items: center;\n  padding-left: 6px;\n  font-size: 11px;\n  color: var(--text-muted);\n  border-right: 1px solid var(--border);\n  white-space: nowrap;\n  overflow: hidden;\n}\n.jp-gantt-today {\n  position: absolute;\n  top: 0; bottom: 0;\n  width: 1px;\n  background: rgba(255, 100, 100, 0.6);\n  z-index: 2;\n  pointer-events: none;\n}\n.jp-gantt-row {\n  position: relative;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n}\n.jp-gantt-bar {\n  position: absolute;\n  top: 5px;\n  height: 22px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  cursor: default;\n}\n.jp-gantt-bar-label {\n  font-size: 10px;\n  color: rgba(255,255,255,0.9);\n  padding: 0 6px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Package cards */\n.jp-card {\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  margin: 0 16px 8px;\n  background: var(--bg-secondary);\n  overflow: hidden;\n}\n.jp-card.jp-unread {\n  border-color: #f0a04b44;\n}\n.jp-card-new {\n  border-color: var(--accent-light);\n}\n.jp-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  user-select: none;\n  min-height: 44px;\n}\n.jp-card-header:hover { background: var(--bg-hover); }\n.jp-card-chevron { color: var(--text-muted); flex-shrink: 0; }\n.jp-status-dot {\n  width: 8px; height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.jp-status-dot-btn {\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: transform 0.1s, box-shadow 0.1s;\n}\n.jp-status-dot-btn:hover {\n  transform: scale(1.4);\n  box-shadow: 0 0 0 2px rgba(255,255,255,0.15);\n}\n\n.jp-status-filter {\n  display: flex;\n  gap: 4px;\n  margin-left: 4px;\n}\n.jp-filter-btn {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 3px;\n  border: 1px solid var(--border);\n  background: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color 0.1s, border-color 0.1s;\n}\n.jp-filter-btn:hover { color: var(--text-primary); border-color: var(--text-muted); }\n.jp-filter-btn.active { color: var(--text-primary); border-color: var(--text-secondary); background: var(--bg-active); }\n.jp-pkg-project {\n  font-size: 11px;\n  color: #4fc1ff;\n  background: rgba(79,193,255,0.1);\n  border: 1px solid rgba(79,193,255,0.3);\n  border-radius: 3px;\n  padding: 1px 5px;\n  flex-shrink: 0;\n}\n.jp-pkg-number {\n  font-family: monospace;\n  font-size: 11px;\n  color: var(--text-muted);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  padding: 1px 5px;\n  flex-shrink: 0;\n}\n.jp-pkg-orderno {\n  font-size: 11px;\n  color: #f0a04b;\n  background: rgba(240,160,75,0.1);\n  border: 1px solid rgba(240,160,75,0.3);\n  border-radius: 3px;\n  padding: 1px 5px;\n  flex-shrink: 0;\n}\n.jp-card-name {\n  font-size: 13px;\n  font-weight: 500;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.jp-unread-dot {\n  width: 7px; height: 7px;\n  border-radius: 50%;\n  background: #f0a04b;\n  flex-shrink: 0;\n}\n.jp-card-dates {\n  font-size: 11px;\n  color: var(--text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.jp-card-assignees {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.jp-more-assignees {\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-left: 2px;\n}\n.jp-card-status-label {\n  font-size: 11px;\n  font-weight: 500;\n  flex-shrink: 0;\n  min-width: 80px;\n  text-align: right;\n}\n.jp-card-actions {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.jp-card-actions .jp-edit-del {\n  display: flex;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity 0.1s;\n}\n.jp-card-header:hover .jp-card-actions .jp-edit-del { opacity: 1; }\n@media (hover: none) {\n  .jp-card-actions .jp-edit-del { opacity: 1; }\n}\n\n/* ── Mobile ── */\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  /* Toolbar: title on top, filters + new button below */\n  .jp-wrap .module-toolbar {\n    flex-wrap: wrap;\n    padding: 8px 12px;\n    gap: 6px;\n  }\n  .jp-wrap .module-toolbar-title {\n    width: 100%;\n    margin-right: 0;\n  }\n  .jp-status-filter { flex: 1; }\n  .jp-filter-btn {\n    font-size: 11px;\n    padding: 5px 6px;\n    flex: 1;\n    text-align: center;\n  }\n\n  /* Cards */\n  .jp-card { margin: 0 8px 6px; }\n  .jp-card-header { gap: 6px; padding: 10px 10px; min-height: 52px; }\n  .jp-card-dates        { display: none; }\n  .jp-card-status-label { display: none; }\n  .jp-card-assignees    { display: none; }\n  .jp-card-name { font-size: 13px; }\n  .jp-gantt-wrap { display: none; }\n\n  /* Bigger tap targets for card action buttons */\n  .jp-card-actions { gap: 6px; }\n  .jp-card-actions .btn-icon { width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; }\n\n  /* Status dot bigger tap target */\n  .jp-status-dot-btn { width: 20px; height: 20px; }\n\n  /* Form: stack all rows vertically */\n  .jp-form-row { flex-direction: column; gap: 8px; }\n  .jp-form-label { min-width: 0; }\n  .jp-input { font-size: 16px !important; } /* prevent iOS zoom */\n\n  /* Bigger checklist touch targets */\n  .jp-checkitem { padding: 10px 6px; min-height: 44px; font-size: 13px; }\n  .jp-checkitem input[type=\"checkbox\"] { width: 18px; height: 18px; flex-shrink: 0; }\n  .jp-checklist { max-height: 220px; }\n  .jp-checklist-scroll { max-height: 260px; }\n\n  /* File picker: stack vertically */\n  .jp-filepicker-body { flex-direction: column; height: auto; }\n  .jp-filepicker-folders {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid var(--border);\n    max-height: 130px;\n    display: flex;\n    flex-wrap: wrap;\n    padding: 4px;\n    gap: 4px;\n  }\n  .jp-filepicker-folder { width: auto; padding: 6px 10px; border: 1px solid var(--border); border-radius: 3px; }\n  .jp-filepicker-folder.active { background: var(--bg-active); }\n  .jp-filepicker-files { max-height: 200px; }\n  .jp-filepicker-file { padding: 8px 6px; min-height: 40px; font-size: 13px; }\n\n  /* Form action buttons full width */\n  .jp-form-actions { flex-direction: column; }\n  .jp-form-actions .btn-primary,\n  .jp-form-actions .btn-secondary { width: 100%; justify-content: center; padding: 10px; font-size: 14px; }\n\n  /* Cable table: full columns, horizontal scroll */\n  .jp-detail-full { overflow-x: auto; -webkit-overflow-scrolling: touch; }\n  .jp-cable-table { min-width: 480px; width: max-content; }\n  .jp-cable-table td:last-child input[type=\"checkbox\"] { width: 22px; height: 22px; }\n\n  /* Detail items bigger */\n  .jp-detail-item { padding: 6px 0; font-size: 13px; }\n\n  .jp-body { padding-bottom: 60px; }\n}\n\n.jp-card-title {\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 14px 0;\n  color: var(--text-primary);\n}\n.jp-card-body {\n  padding: 12px 14px 14px;\n  border-top: 1px solid var(--border);\n}\n\n/* Form */\n.jp-form { display: flex; flex-direction: column; gap: 10px; }\n.jp-form-row { display: flex; gap: 12px; flex-wrap: wrap; }\n.jp-form-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 11px;\n  color: var(--text-muted);\n  flex: 1;\n  min-width: 120px;\n}\n.jp-input {\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  color: var(--text-primary);\n  font-size: 13px;\n  padding: 5px 8px;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n}\n.jp-input:focus { border-color: var(--accent-light); }\n.jp-textarea { resize: vertical; min-height: 60px; font-family: inherit; }\n.jp-form-section {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 4px 0 2px;\n  border-bottom: 1px solid var(--border);\n}\n.jp-checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 120px;\n  overflow-y: auto;\n  padding: 2px 0;\n}\n.jp-checklist-scroll { max-height: 140px; }\n.jp-checkitem {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 2px;\n}\n.jp-checkitem:hover { background: var(--bg-hover); }\n.jp-search-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  color: var(--text-muted);\n  margin-bottom: 2px;\n}\n.jp-search-input { flex: 1 1 160px; }\n.jp-search-row .group-filter { width: auto; flex: 0 1 170px; }\n.jp-select-all { font-size: 12px; padding: 4px 10px; white-space: nowrap; }\n.jp-form-section .jp-muted { text-transform: none; letter-spacing: 0; font-weight: 400; }\n.jp-tag {\n  font-family: monospace;\n  font-size: 11px;\n  background: var(--bg-tertiary);\n  padding: 1px 5px;\n  border-radius: 2px;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n.jp-muted { font-size: 11px; color: var(--text-muted); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.jp-files-selected { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 6px; }\n.jp-file-chip {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  padding: 2px 6px;\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n.jp-file-chip-remove {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n.jp-file-chip-remove:hover { color: #e06c75; }\n.jp-add-files-btn { margin-top: 2px; }\n.jp-form-actions { display: flex; gap: 8px; margin-top: 4px; }\n\n/* File picker */\n.jp-filepicker {\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--bg-secondary);\n  margin-top: 6px;\n  overflow: hidden;\n}\n.jp-filepicker-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 10px;\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border);\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n.jp-filepicker-body { display: flex; height: 160px; }\n.jp-filepicker-folders {\n  width: 140px;\n  border-right: 1px solid var(--border);\n  overflow-y: auto;\n  padding: 4px 0;\n}\n.jp-filepicker-folder {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  text-align: left;\n  padding: 5px 10px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.jp-filepicker-folder:hover, .jp-filepicker-folder.active { background: var(--bg-hover); color: var(--text-primary); }\n.jp-filepicker-files {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.jp-filepicker-file {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  padding: 3px 4px;\n  border-radius: 2px;\n  cursor: pointer;\n}\n.jp-filepicker-file:hover { background: var(--bg-hover); }\n.jp-filepicker-empty { font-size: 11px; color: var(--text-muted); padding: 8px; }\n\n/* Detail view */\n.jp-description { font-size: 13px; color: var(--text-secondary); margin: 0 0 10px; line-height: 1.5; }\n.jp-detail-grid { display: flex; gap: 16px; flex-wrap: wrap; }\n.jp-detail-section { flex: 1; min-width: 180px; }\n.jp-detail-full { flex-basis: 100%; min-width: 0; }\n\n/* Cable table inside job package detail */\n.jp-cable-table { width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 4px; }\n.jp-cable-table th {\n  text-align: left;\n  color: var(--text-muted);\n  font-weight: 500;\n  padding: 2px 8px 4px 0;\n  border-bottom: 1px solid var(--border);\n}\n.jp-cable-table td { padding: 3px 8px 3px 0; color: var(--text-secondary); vertical-align: middle; }\n.jp-cable-table tr:hover td { background: var(--bg-hover); }\n.jp-arrow { color: var(--text-muted); padding: 0 2px !important; }\n.jp-detail-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 6px;\n}\n.jp-detail-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 0;\n  font-size: 12px;\n  color: var(--text-secondary);\n  overflow: hidden;\n}\n.jp-file-link {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: var(--accent-light);\n  font-size: inherit;\n  font-family: inherit;\n  text-align: left;\n}\n.jp-file-link:hover { text-decoration: underline; }\n\n/* Tag + yellow/red notice badges (same badges as the Items/Cables lists) */\n/* Photo button + notices next to a cable/item tag. Photo first, so the cameras line up */\n.jp-icons { display: inline-flex; align-items: center; gap: 4px; flex-shrink: 0; }\n.jp-icons .photo-btn { flex-shrink: 0; }\n.jp-cable-table td.jp-icons-td { padding-right: 12px; white-space: nowrap; }\n.jp-detail-item .jp-icons { min-width: 46px; }\n.jp-icons .rn-wrap { flex-wrap: nowrap; }\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .jp-icons { gap: 6px; }\n  .jp-icons .photo-btn { width: 30px; height: 30px; }\n  .jp-detail-item .jp-icons { min-width: 56px; }\n}\n.jp-detail-item:hover .photo-btn-empty { opacity: 0.55; }\n.jp-detail-item .photo-btn-empty:hover { opacity: 1; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
